module.exports = __webpack_public_path__ + "static/img/mysql.c0482f41.png";